import { ComponentPropsWithoutRef, FC, ReactNode } from 'react';
import { Checkbox } from 'react-daisyui';
import { cn } from '@/utils/classNames.ts';

type CheckboxInputProps = ComponentPropsWithoutRef<typeof Checkbox> & {
  label?: ReactNode;
  error?: string;
  wrapperClassName?: string;
};

const CheckboxInput: FC<CheckboxInputProps> = ({ wrapperClassName, label, error, ...args }) => {
  return (
    <label className={cn('label justify-start gap-2', wrapperClassName)}>
      <Checkbox {...args} />
      <span
        className={cn('label-text', {
          'text-error': !!error,
        })}
      >
        {label}
      </span>
    </label>
  );
};

export default CheckboxInput;
